import React from "react"
import { BookOpenIcon } from "@heroicons/react/24/outline"
import Typography from "aldoo-ra/Typography"
import { twMerge } from "tailwind-merge"

const ReadTimeBadge = ({
  className = "",
  data,
  iconClassName = "text-gray_800",
  textClassName = "text-gray_800",
  variant = "txt1_accent",
  top = "4",
  topMd = "7",
  right = "4",
  rightMd = "7",
  position = "absolute",
  bgColor = "bg-white/50",
}) => {
  // Create position classes for twMerge
  const topClass = `top-${top}`
  const topMdClass = `md:top-${topMd}`
  const rightClass = `right-${right}`
  const rightMdClass = `md:right-${rightMd}`

  return (
    <div
      className={twMerge(
        position,
        "min-w-[106px] h-8 flex items-center justify-center",
        bgColor,
        "rounded-full backdrop-blur-sm px-2 z-10",
        topClass,
        topMdClass,
        rightClass,
        rightMdClass,
        className
      )}
    >
      <BookOpenIcon className={twMerge("w-4 h-4 mr-1", iconClassName)} />
      <Typography className={textClassName} variant={variant}>
        {data.read_time || "5 min"}
      </Typography>
    </div>
  )
}

export default ReadTimeBadge
